import { render, staticRenderFns } from "./PicturesDialog.vue?vue&type=template&id=898b0ffa"
import script from "./PicturesDialog.vue?vue&type=script&lang=js"
export * from "./PicturesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports